import { render, staticRenderFns } from "./delete_button.vue?vue&type=template&id=371225f3&scoped=true&lang=pug"
import script from "./delete_button.vue?vue&type=script&lang=js"
export * from "./delete_button.vue?vue&type=script&lang=js"
import style0 from "./delete_button.vue?vue&type=style&index=0&id=371225f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371225f3",
  null
  
)

export default component.exports